var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16107_20799)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23.5102,
    cy: 23.5102,
    r: 23.5102,
    fill: "#A1A4AD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 23.5773C0 10.5558 10.5258 0 23.5103 0C36.4947 0 47.0204 10.5558 47.0204 23.5773C47.0204 29.5641 44.7909 35.0255 41.1257 39.1837C40.9935 34.8911 36.9731 30.2185 31.1619 28.4217C29.0785 30.306 26.413 31.2025 23.5102 31.2025C20.5375 31.2025 17.8186 30.2459 15.7138 28.2792C9.95238 29.9316 5.84365 34.4003 5.32989 38.5257C1.9998 34.4575 0 29.2515 0 23.5773ZM19.0681 27.5588C20.416 28.2421 21.9339 28.6367 23.5448 28.6367C25.096 28.6367 26.5594 28.269 27.8708 27.6316C31.1997 26.0126 33.5061 22.5994 33.5061 18.6471C33.5061 13.1388 29.0381 8.65729 23.5448 8.65729C18.052 8.65729 13.5836 13.1388 13.5836 18.6471C13.5836 22.5396 15.82 25.9112 19.0681 27.5588Z",
    fill: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.3467,
    y: 31.3467,
    width: 15.6735,
    height: 15.6735,
    rx: 7.83673,
    fill: "url(#paint0_linear_16107_20799)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.3467,
    y: 31.3467,
    width: 15.6735,
    height: 15.6735,
    rx: 7.83673,
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7521 39.8765V42.5005H38.7448V39.8765H36.2451V38.8692H38.7448V36.2451H39.7521V38.8692H42.2518V39.8765H39.7521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16107_20799",
    x1: 31.0674,
    y1: 50.8584,
    x2: 42.0665,
    y2: 29.8783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16107_20799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.cd88e4e2423cc48aa192c72a1dcf9b65.svg";
export { ForwardRef as ReactComponent };